<template>
  <v-dialog v-model="dialog" persistent :width="dialogWidth">
    <template v-slot:activator="{ on }">
      <v-btn small icon v-on="on" width="40">
        <!-- BEGIN::Modified.by.KWShin.2023.10.26.-->
        <!--v-icon small @click="setComponent('', 'preference')">mdi-cogs</v-icon-->
        <!--v-icon small @click.stop="role === 'ROLE_ADMIN' ? setComponent('', 'preference') : showMessage()">mdi-cogs</v-icon-->
        <v-icon small @click.stop="showPreference()">mdi-cogs</v-icon>
        <!-- FINISH::Modified.by.KWShin.2023.10.26.-->
      </v-btn>
    </template>
    <v-card class="preference-wrapper" @contextmenu.prevent>
      <v-toolbar dense>
        <v-btn small icon @click="setComponent('', 'preference')">
          <v-icon small>mdi-home</v-icon>
        </v-btn>
        <p class="preference-title">{{ title }}</p>
        <v-spacer></v-spacer>
        <v-btn small icon @click="dialog = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container :class="classPreferenceContents">
        <vue-scrollbar class="preference-scrollbar">
          <component v-bind:is="component" :set-component="setComponent" />
        </vue-scrollbar>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
// Added.by.KWShin.2023.10.26.
import { mapState } from 'vuex';
import bus from '@/utils/bus';
import VDialog from '@/components/dialog/VDialog';
import preference from '../../preference';

const DIALOG_WIDTH = 820;
const DIALOG_MAX_WIDTH = 1300;
const CONTENT_HEIGHT = 400;
const CONTENT_MAX_HEIGHT = 700;

export default {
  data: () => ({
    dialog: false,
    dialogWidth: DIALOG_WIDTH,
    contentHeight: CONTENT_HEIGHT,
    component: preference,
    title: '',
  }),
  components: {
    VDialog,
    preference,
  },
  watch: {
    contentHeight(value) {
      const target = document.querySelector('.preference-contents .vue-scrollbar') || {};
      target.style.height = `${value}px`;
    },
  },
  computed: {
    // Added.by.KWShin.2023.10.26.
    ...mapState('common/user', ['role']),
    classPreferenceContents() {
      return {
        'preference-contents': true,
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  methods: {
    // BEGIN::Added.by.KWShin.2024.07.05.
    showPreference() {
      this.role === 'ROLE_ADMIN' ? this.setComponent('', 'preference') : this.showMessage();
      this.hideMainMenu();
    },
    hideMainMenu() {
      bus.$emit('toggle-main-menu', false);
    },
    // FINISH::Added.by.KWShin.2024.07.05.
    // BEGIN::Added.by.KWShin.2023.10.26.
    // ROLE_ADMIN이 아닌 경우에는 비어있는 설정메뉴목록 화면을 보여주지 않고 접근권한없음 메시지를 띄운다.
    showMessage() {
      this.$dialog.alert(this.$t('security.access.denied'));
    },
    // FINISH::Added.by.KWShin.2023.10.26.
    async setComponent(title, path) {
      // Added.by.KWShin.2023.10.26.
      this.dialog = true;
      this.title = title;
      this.component = (await import(`../../../views/${path}`)).default;
    },
  },
  updated() {
    const offsetWidth = 12;
    // const offsetHeight = 6;
    const target = document.querySelector('.preference-contents .vue-scroll-view')?.firstElementChild;
    const width = target ? target.offsetWidth + offsetWidth : DIALOG_WIDTH;
    const height = target ? target.offsetHeight : CONTENT_HEIGHT;
    this.dialogWidth = width > DIALOG_MAX_WIDTH ? DIALOG_MAX_WIDTH : width;
    this.contentHeight = height > CONTENT_MAX_HEIGHT ? CONTENT_MAX_HEIGHT : height < CONTENT_HEIGHT ? CONTENT_HEIGHT : height;
  },
};
</script>
